module.exports = __webpack_public_path__ + "3442baa987516299443041727741ccf1.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/icons/build/fonts/spark-icon-fill.woff2
// module id = 1410
// module chunks = 0